var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonBinary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E0845",
    d: "M12 5.193c.251 0 .455.209.455.467l-.001 1.19 1.062-.612a.476.476 0 11.475.823l-1.041.6 1.041.601a.475.475 0 11-.475.823l-1.062-.613v1.28c2.472.23 4.431 2.318 4.541 4.887l.005.228C17 17.697 14.756 20 12 20s-5-2.304-5-5.133c0-2.673 2.001-4.878 4.545-5.114V8.472l-1.061.613a.476.476 0 01-.475-.823l1.04-.601-1.04-.6a.474.474 0 11.475-.823l1.061.612V5.66c0-.23.161-.42.373-.46zm0 5.474c-2.265 0-4.09 1.875-4.09 4.2s1.825 4.2 4.09 4.2c2.265 0 4.09-1.875 4.09-4.2s-1.825-4.2-4.09-4.2z"
  })));
}
export default SvgNonBinary;